import { render, staticRenderFns } from "./umfragen.vue?vue&type=template&id=145d86ab&scoped=true"
import script from "./umfragen.vue?vue&type=script&lang=js"
export * from "./umfragen.vue?vue&type=script&lang=js"
import style0 from "./umfragen.vue?vue&type=style&index=0&id=145d86ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d86ab",
  null
  
)

export default component.exports